export class Validations {
  static SMSLimit = 160;
}
